var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},_vm._l((_vm.items),function(item){return _c('v-col',{class:['d-flex justify-center align-center pa-1'],attrs:{"cols":"4","md":"3"}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{
				name: item.to,
			}}},[_c('SimpleCard',{staticClass:"animate__animated animate__fadeIn",attrs:{"category":item}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }